import fionaLogo from './fiona-logo.svg'
import Image from 'next/legacy/image'
import Link from 'next/link'

export const FionaLogo = () => (
	<Link href={'/'} passHref>
		<Image width={100} height={30} src={fionaLogo} alt="Fiona Logo" />
	</Link>
)
